import { httpFile } from "./http";

const platformId = process.env.REACT_APP_PLATFORM_ID;

export const fileService = {
  get(path, callback, errCallback) {
    const separator = path.includes("?") ? "&" : "?";
    return httpFile
      .get(`${path}${separator}platformId=${platformId}`)
      .then((response) => {
        callback(response);
      })
      .catch((error) => {
        if (errCallback) {
          errCallback(error);
        }
      });
  },

  post(
    path,
    payload,
    callback,
    errCallback,
    finallyCallback,
    onUploadProgress = () => {},
    contentType = "application/json"
  ) {
    if (contentType == "multipart/form-data") {
      payload.append("FolderName", "TPM");
      payload.append("PlatformId", platformId);
    }
    return httpFile
      .post(path, payload, {
        headers: { "Content-Type": contentType },
        onUploadProgress,
      })
      .then((response) => {
        callback(response);
      })
      .catch((error) => {
        if (errCallback) {
          errCallback(error);
        }
      })
      .finally(() => {
        if (finallyCallback) {
          finallyCallback();
        }
      });
  },

  delete(path, payload, callback, errCallback, finallyCallback) {
    return httpFile
      .delete(path, { data: Array.isArray(payload) ? payload : [payload] })
      .then((response) => {
        if (callback) callback(response);
      })
      .catch((error) => {
        console.error(
          "Delete request failed:",
          error.response?.data || error.message
        );
        if (errCallback) errCallback(error.response?.data || error);
      })
      .finally(() => {
        if (finallyCallback) finallyCallback();
      });
  },
};
